<template>
    <div class="d-flex">
        <div class="vc-timezone-box u-palt">
            <span>
                {{ helper.dateForHuman(consultation.start_time, 'Asia/Tokyo', { exceptYear: exceptYear }) }}
            </span>
            <span :class="helper.dayForHumanCSS(consultation.start_time , 'Asia/Tokyo')">
                {{ helper.dayForHuman(consultation.start_time, 'Asia/Tokyo', { bracket: true }) }}
            </span>
            <span class="ml-2">
                {{ `${helper.timeForHuman(consultation , 'Asia/Tokyo')} （日本時間）` }}
            </span>
        </div>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'

    /**
     * タイムゾーン併記（JST固定）
     */
    export default  {
        name: 'TimezoneBoxJst',

        props: {
            consultation: {
                type: Object,
                required: true,
            },
            timezone: {
                type: String,
                required: true,
            },
            exceptYear: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
            }
        },
    }
</script>

<style scoped lang="scss">
.vc-timezone-box {
    margin-top: 5px;
    padding: 5px 10px;
    color: #6e7275;
    background-color: #eee;
    border-radius: 4px;
    border: 1px solid #e6e6e6;

    span {
        font-size: 12px;
        line-height: 1.4;
    }
}
</style>
